import {SystemRoutes} from '../../../Utils/RouteUtils';

interface AlarmTotalizersRefreshPolicyArgs {
    pathname: string;
    isLoading: boolean;
    alarmUpdateInterval: number;
    alarmSoundCountRefreshIntervalByms: number;
}

interface AlarmTotalizersRefreshPolicy {
    delay: number;
    restartKey: string;
}

export const getAlarmTotalizersRefreshPolicy = ({
    pathname,
    isLoading,
    alarmUpdateInterval,
    alarmSoundCountRefreshIntervalByms,
}: AlarmTotalizersRefreshPolicyArgs): AlarmTotalizersRefreshPolicy => {
    const isOverviewAlarmsPage = pathname.endsWith(SystemRoutes.DASHBOARD_OVERVIEW_ALARMS);

    return {
        delay: isOverviewAlarmsPage ? alarmUpdateInterval : alarmSoundCountRefreshIntervalByms,
        restartKey: isOverviewAlarmsPage ? `alarm-page:${isLoading}` : 'alarm-sound',
    };
};
